import React, { useState } from 'react';
import Button from '../../ui/Button';

const ActionButtonRenderer = ({ 
  actions = [],
  layout = "horizontal", // horizontal, vertical, grid
  size = "md", // sm, md, lg
  onActionClick,
  isLoading = false,
  className = ""
}) => {
  const [loadingActionIds, setLoadingActionIds] = useState(new Set());

  const handleActionClick = async (action) => {
    if (!onActionClick) return;
    
    setLoadingActionIds(prev => new Set([...prev, action.id]));
    
    try {
      await onActionClick(action);
    } catch (error) {
      console.error(`Error executing action ${action.id}:`, error);
    } finally {
      setLoadingActionIds(prev => {
        const newSet = new Set(prev);
        newSet.delete(action.id);
        return newSet;
      });
    }
  };

  const getButtonVariant = (actionType) => {
    switch (actionType) {
      case 'primary':
        return 'primary';
      case 'secondary':
        return 'secondary';
      case 'danger':
        return 'danger';
      case 'danger-outline':
        return 'danger-outline';
      case 'success':
        return 'success';
      case 'success-outline':
        return 'success-outline';
      case 'teal-outline':
        return 'teal-outline';
      case 'outline':
        return 'outline';
      case 'warning':
        return 'warning';
      case 'yellow':
        return 'yellow';
      case 'offer':
        return 'offer';
      default:
        return 'secondary';
    }
  };

  const getLayoutClasses = () => {
    switch (layout) {
      case 'vertical':
        return 'flex flex-col space-y-2';
      case 'grid':
        return 'grid grid-cols-2 gap-2 sm:grid-cols-3';
      case 'horizontal':
      default:
        return 'flex flex-wrap gap-2';
    }
  };

  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <div className={`action-buttons-container ${getLayoutClasses()} ${className}`}>
      {actions.map(action => {
        const isActionLoading = loadingActionIds.has(action.id) || isLoading;
        const IconComponent = action.icon;
        
        return (
          <Button
            key={action.id}
            variant={getButtonVariant(action.type)}
            size={size}
            onClick={() => handleActionClick(action)}
            disabled={isActionLoading}
            isLoading={isActionLoading}
            className="flex items-center justify-center"
          >
            {!isActionLoading && IconComponent && (
              <IconComponent className="h-4 w-4 mr-2" />
            )}
            {action.label}
          </Button>
        );
      })}
    </div>
  );
};

export default ActionButtonRenderer; 